'use client'

import { type FC } from 'react'

import { useStoryblokStory } from '../../context/StoryblokStoryContext'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokProductSearchType } from '../../storyblok'
import { useStoryblokServerSideData } from '../../storyblok-server-side-data/context/storyblokServerSideDataContext'
import { StoryblokCategoryProductSearch } from '../StoryblokAkeneoCategoryPage'
import { StoryblokBrandProductSearch } from '../StoryblokBrandPage/components/StoryblokBrandProductSearch'

export const StoryblokProductSearch: FC<
  StoryblokComponentProps<StoryblokProductSearchType>
> = (props) => {
  const { blok } = props
  const story = useStoryblokStory()
  const { data, error } = useStoryblokServerSideData(blok)

  if (!data || error) {
    throw new Error('Failed to fetch storyblok product search data')
  }

  if (story.content.component === 'BrandPage') {
    return (
      <StoryblokBrandProductSearch
        {...props}
        productSearchConfig={data.productSearchConfig}
      />
    )
  }

  if (story.content.component === 'AkeneoCategoryPage') {
    return (
      <StoryblokCategoryProductSearch
        {...props}
        productSearchConfig={data.productSearchConfig}
      />
    )
  }

  return null
}
